import { Row, Col } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const formatNumber = (value) => {
  if (value === null || value === undefined) return "";
  const clean = value.toString().replace(/[^0-9.]/g, ""); // remove commas, $ etc.
  const num = Number(clean);
  if (isNaN(num)) return value; // fallback
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const HigherEducation = () => {
  const tableData = [
    {
      department: "Capital Projects (One-Time)",
      amount: "114",
      color: "#D5D6EA90",
    },
    {
      department: "Workforce & Strategic Initiatives (Ongoing)",
      amount: "10.5",
      color: "#AA6C3990",
    },
    {
      department: "Technical College Expansion (Ongoing)",
      amount: "10.7",
      color: "#FFCCCB90",
    },
    {
      department: "Higher Ed Performance Funding (Ongoing)",
      amount: "20",
      color: "#61405190",
    },
    {
      department: "Strategic Reinvestment (Ongoing)",
      amount: "60.5",
      color: "#52D01790",
    },
    {
      department: "Higher Education Capital Projects Fund (HECPF)",
      amount: "100.7",
      color: "#F6728090",
    },
  ];

  const totalAmount = tableData.reduce(
    (sum, row) => sum + Number(row.amount),
    0
  );

  const chartLabels = tableData.map((row) => row.department);
  const chartValues = tableData.map((row) =>
    parseFloat(row.amount.replace(/[^0-9.]/g, ""))
  );
  const chartColors = tableData.map((row) => row.color.replace("90", "")); // solid color

  const chartData = {
    labels: chartLabels,
    datasets: [
      {
        label: "Amount ($ Million)",
        data: chartValues,
        backgroundColor: chartColors, // solid colors
        // border: 1,
        borderRadius: 8,
        barThickness: 35,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    indexAxis: "y", // Horizontal bar
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.label}: ${formatNumber(ctx.raw)}`,
        },
      },
      datalabels: {
        display: true,
        color: "#000",
        anchor: "end",
        align: "right",
        formatter: (value) => formatNumber(value),
        font: { weight: "bold", size: 13 },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Amount ($ Million)",
          color: "#111",
          font: { weight: "bold" },
        },
        ticks: { color: "#333" },
        grid: { display: true, color: "#ddd" },
      },
      y: {
        title: {
          display: true,
          text: "Category/Program",
          color: "#111",
          font: { weight: "bold" },
        },
        ticks: {
          color: "#111",
          font: { size: 12, weight: "500" },
        },
        grid: { display: false },
      },
    },
  };

  return (
    <div className="max-w-7xl mx-auto px-4">
      <h3>
        Higher Education Budget Overview ($
        {Number("3200").toLocaleString("en-US")} Million, 10%)
      </h3>{" "}
      <Row className="gy-4 flex items-center">
        {/* Table */}
        <Col md={12}>
          <div className="overflow-x-auto flex items-center">
            <table className="w-full border-collapse text-center border shadow-md overflow-hidden mt-6">
              <thead>
                <tr>
                  <th
                    className="p-2 text-left border"
                    style={{ backgroundColor: "#bfdbfe" }}
                  >
                    Category/Program
                  </th>
                  <th
                    className="p-2 text-right border "
                    style={{ backgroundColor: "#bfdbfe" }}
                  >
                    Amount ($ Million)
                  </th>
                </tr>
              </thead>

              <tbody>
                {tableData.map((row, index) => (
                  <tr
                    key={index}
                    className="odd:bg-gray-100 even:bg-white hover:bg-gray-100 transition border"
                  >
                    <td
                      className="p-2 text-left border"
                      // style={{ backgroundColor: row.color }}
                    >
                      {row.department}
                    </td>
                    <td className="p-2 text-right border">
                      {formatNumber(row.amount)}
                    </td>
                  </tr>
                ))}
                {/* ✅ TOTAL ROW */}
                <tr className="bg-blue-50 font-semibold border-t-2">
                  <td className="p-2 text-left border">Total</td>
                  <td className="p-2 text-right border">
                    {formatNumber(totalAmount)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>
        <Col md={12}>
          <div className="overflow-x-auto">
            <div className="p-3 bg-white rounded-3 border min-w-[900px] sm:min-w-full">
              <Bar data={chartData} options={chartOptions} />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default HigherEducation;
